/* eslint react/jsx-filename-extension: 0 */

import React from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/browser'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { SkeletonTheme } from 'react-loading-skeleton'
import { PersistGate } from 'redux-persist/es/integration/react'
import '@fontsource/nunito-sans'
import '@fontsource/nunito-sans/300.css'
import '@fontsource/nunito-sans/400.css'
import '@fontsource/nunito-sans/600.css'
import '@fontsource/nunito-sans/700.css'
import 'react-tabs/style/react-tabs.css'
import 'react-loading-skeleton/dist/skeleton.css'
import '../library/segment.config'
import { configureStore } from 'store'
import { StyleSheetManager } from 'styled-components'
import isPropValid from '@emotion/is-prop-valid'
import App from './containers/App'
import './i18n'
import 'rc-slider/assets/index.css'
import './styles.css'
const { persistor, store } = configureStore()
import TagManager from 'react-gtm-module'

// Initialize GTM with your GTM ID
const tagManagerArgs = {
  gtmId: import.meta.env.VITE_GTM_ID, // although it is the same id for both TEST and PROD, keeping it as an env variable for flexibility.
  auth: import.meta.env.VITE_GTM_AUTH // needed to control environment TEST or PROD
}

TagManager.initialize(tagManagerArgs)

const Root = () => (
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <SkeletonTheme baseColor="#202020" highlightColor="#444">
        <StyleSheetManager shouldForwardProp={shouldForwardProp}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </StyleSheetManager>
      </SkeletonTheme>
    </PersistGate>
  </Provider>
)

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://1cc47cdd244a4095890ba40eccc4de06@sentry.io/1731180'
  })
}

// Get the root element
const rootElement = document.getElementById('root')

// Create a root
const root = createRoot(rootElement)

// Initial render
root.render(<Root />)

// This implements the default behavior from styled-components v5
function shouldForwardProp(propName, target) {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName)
  }
  // For other elements, forward all props
  return true
}
